import { useMutation } from '@tanstack/react-query';
import { MigrateQuoteOfferingPostRequestBody, MigrateQuoteOfferingPostResponse } from '@lio/api-types';
import { useClient } from '@utils/api-client';

export const useMigrateQuoteOffering = () => {
  const client = useClient();

  const mutationFn = async (body: MigrateQuoteOfferingPostRequestBody) =>
    client.post(`quote-copy/migrate-offering`, { json: body }).json<MigrateQuoteOfferingPostResponse>();

  const result = useMutation({ mutationFn });
  return { ...result, migrateQuoteOffering: result.mutateAsync };
};
